import NotFound from '@/_application/core/components/ui/not-found';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import React from 'react';
import PopularKeywordsHome from '@/_application/modules/home/popular-keyword-home';

const SearchEmpty = () => {
    const babySadImage = getImageAssetUrl('images/baby-sad.png');

    return (
        <div className="w-full">
            <div className="mx-auto flex items-center justify-center">
                <NotFound className="mx-auto w-7/12 bg-secondary" imageUrl={babySadImage} />
            </div>
            <div className="mb-5">
                <PopularKeywordsHome />
            </div>
        </div>
    );
};

export default SearchEmpty;
